import React from "react";
import { Link } from "react-router-dom";

export default function NotFoundPage() {
  return (
    <main
      id="main-content"
      style={{
        minHeight: "70vh",
        display: "grid",
        placeItems: "center",
        padding: "48px 20px",
        background: "linear-gradient(180deg, #f4f8fc 0%, #ffffff 100%)",
      }}
    >
      <section
        style={{
          maxWidth: 720,
          width: "100%",
          background: "#ffffff",
          border: "1px solid #e6edf6",
          borderRadius: 20,
          boxShadow: "0 16px 40px rgba(15, 23, 42, 0.08)",
          padding: "36px 28px",
          textAlign: "center",
        }}
      >
        <p
          style={{
            margin: 0,
            color: "#4c81cb",
            fontWeight: 700,
            letterSpacing: "0.08em",
          }}
        >
          404
        </p>
        <h1 data-page-heading="true" style={{ margin: "12px 0 8px", color: "#0f172a" }}>Page Not Found</h1>
        <p style={{ margin: "0 0 24px", color: "#475569", lineHeight: 1.6 }}>
          The URL you entered does not exist on ClearBadge. Check the link, or head back to a valid page.
        </p>
        <div
          style={{
            display: "flex",
            gap: 12,
            justifyContent: "center",
            flexWrap: "wrap",
          }}
        >
          <Link
            to="/"
            style={{
              textDecoration: "none",
              background: "#4c81cb",
              color: "#ffffff",
              padding: "10px 16px",
              borderRadius: 10,
              fontWeight: 600,
            }}
          >
            Go Home
          </Link>
          <Link
            to="/find-a-pro"
            style={{
              textDecoration: "none",
              border: "1px solid #c8d7ec",
              color: "#1e293b",
              padding: "10px 16px",
              borderRadius: 10,
              fontWeight: 600,
              background: "#ffffff",
            }}
          >
            Find a Pro
          </Link>
        </div>
      </section>
    </main>
  );
}
